<template>
  <div v-if="report.length === 0 && loading === false">
    No data available
  </div>
  <graph-skeleton class="mx-3" v-else-if="report.length === 0"></graph-skeleton>
  <div v-else>
    <highmaps :options="options" ref="highcharts"></highmaps>
  </div>
</template>


<script>
import GraphSkeleton from '@/reports/components/graphs/GraphSkeleton'
import map from './statesMap.json'
import { getTimeZoneOffsetMillis, graphColors, getPrettyStatName, formatStat, getFormattedDate } from '@/reports/components/ReportUtils'
import { getTooltipHTML } from '@/reports/components/graphs/ReportGraphUtils'
import { getCSSVariable } from '@/components/utils.js'
import tinycolor from 'tinycolor2'

export default {
  name: 'StatesMap',
  props: {
    report: { required: true, type: Array },
    //stats: { required: true, type: Array },
    //fields: { required: true, type: Array },
    loading: { type: Boolean, default: true }
  },
  data () {
    return {

    }
  },
  computed: {
    primaryColor () {
      return getCSSVariable('primary')
    },
    options () {
      return {
        title: false,
        legend: false,
        chart: {
          map: map
        },
        colorAxis: {
            min: 1,
            type: 'linear',
            minColor: tinycolor(this.primaryColor).lighten(30).toString(),
            maxColor: tinycolor(this.primaryColor).toString(),
        },
        series: [{
          name: 'Unique Users',
          borderColor: '#FFFFFF',
          nullColor: '#D3DAE0',
          borderWidth: 0.2,
          data: this.processedData,
          keys: ['auctions', 'value'],
          joinBy: ['hasc','geo_region'],
          states: {
            hover: {
              color: tinycolor(this.primaryColor).darken(10).saturate(30).toString()
            }
          },
        }],
        tooltip: {
          useHTML: true,
          borderColor: '#1C1D29',
          backgroundColor: '#1C1D29',
          borderRadius: 5,
          followPointer: true,
          formatter: function () {
            let title = this.point.name
            return getTooltipHTML(title, [{ name: 'Unique Users', color: this.point.color, value: formatStat('unique_users', this.point.value)}])
          }
        },
        credits: {
          enabled: false
        }
      }
    },
    processedData () {
      let data = []
      for (let row of this.report) {
        data.push({ geo_region: 'US.' + row.geo_region.toUpperCase(), value: Number(row.unique_users) })
      }
      return data
    }
  },
  components: {
    GraphSkeleton
  }
}
</script>


// WEBPACK FOOTER //
// src/reports/components/maps/StatesMap.vue